import React, { useContext } from "react"
import { View, ScrollView, StyleSheet, Text } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import BrevetFunnelHeader from "./BrevetFunnelHeader"
import DownloadAppButton from "../../student/tutoring/DownloadAppButton"

/**
 * Écran "Téléchargez l'app" partagé entre funnels (brevet, cours d'été) —
 * dernière étape post-confirmation. Chaque funnel l'instancie avec le prénom
 * (depuis son Context) et sa tracking source.
 */

const BENEFITS = [
    { icon: "chart-line", text: "Suivez les séances et bilans de cours en temps réel." },
    { icon: "comments", text: "Échangez directement avec le tuteur." },
    { icon: "bell", text: "Recevez les rappels avant chaque séance." },
    { icon: "trophy", text: "Visualisez la progression de votre enfant." },
]

const BenefitRow = ({ icon, text }) => (
    <View style={styles.benefitRow}>
        <View style={styles.benefitIcon}>
            <FontAwesome5 name={icon} solid size={13} color={theme.colors.primary} />
        </View>
        <Text style={styles.benefitText}>{text}</Text>
    </View>
)

const FunnelAppDownload = ({ firstname, trackingSource, hideLogo = false }) => {
    const dimensions = useContext(DimensionsContext)
    const containerWidth = Math.min(dimensions?.width || 400, 460)

    return (
        <View style={styles.root}>
            <View style={[styles.frame, { width: containerWidth }]}>
                <BrevetFunnelHeader step={4} total={4} hideBack hideStep hideLogo={hideLogo} onBack={() => {}} />
                <ScrollView
                    contentContainerStyle={styles.content}
                    showsVerticalScrollIndicator={false}
                >
                    <Text style={styles.title}>Téléchargez l'app Masteur</Text>
                    <Text style={styles.subtitle}>
                        Tout le suivi de {firstname || "votre enfant"} dans votre poche.
                    </Text>

                    <View style={styles.benefitsCard}>
                        {BENEFITS.map((b) => (
                            <BenefitRow key={b.icon} icon={b.icon} text={b.text} />
                        ))}
                    </View>

                    <View style={styles.downloadBlock}>
                        <DownloadAppButton trackingSource={trackingSource} />
                    </View>
                </ScrollView>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    root: {
        flex: 1,
        alignItems: "center",
        backgroundColor: theme.colors.whiteAlmost,
    },
    frame: {
        flex: 1,
        backgroundColor: theme.colors.white,
        paddingHorizontal: 20,
    },
    content: {
        paddingTop: 18,
        paddingBottom: 32,
    },
    title: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 22,
        color: theme.colors.primary,
        textAlign: "center",
        marginBottom: 6,
    },
    subtitle: {
        fontFamily: "Montserrat-Regular",
        fontSize: 13,
        color: theme.colors.grey,
        textAlign: "center",
        marginBottom: 22,
    },
    benefitsCard: {
        backgroundColor: theme.colors.primaryLighter,
        padding: 14,
        borderRadius: 12,
        gap: 10,
        marginBottom: 22,
    },
    benefitRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
    },
    benefitIcon: {
        width: 28,
        height: 28,
        borderRadius: 8,
        backgroundColor: theme.colors.white,
        alignItems: "center",
        justifyContent: "center",
    },
    benefitText: {
        flex: 1,
        fontFamily: "Montserrat-Regular",
        fontSize: 12,
        color: theme.colors.grey,
        lineHeight: 17,
    },
    downloadBlock: {
        alignItems: "center",
        gap: 8,
    },
})

export default FunnelAppDownload
